var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FEC802",
  d: "M10.276.199 13.565 5.9l6.199 1.459c.253.066.316.398.126.597l-4.111 5.039.506 6.63c.063.265-.253.464-.443.332l-5.82-2.586-5.882 2.586c-.19.066-.443-.133-.443-.332l.57-6.63-4.175-5.04c-.19-.198-.063-.53.19-.596L6.417 5.9 9.707.2c.126-.265.442-.265.569 0"
})));
export default SvgStarFilled;